import { render, staticRenderFns } from "./automaticAccess.vue?vue&type=template&id=28393b7a&scoped=true"
import script from "./automaticAccess.vue?vue&type=script&lang=js"
export * from "./automaticAccess.vue?vue&type=script&lang=js"
import style0 from "./automaticAccess.vue?vue&type=style&index=0&id=28393b7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28393b7a",
  null
  
)

export default component.exports